var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPilatesBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.62,345.84h-96V118.76h96ZM297.3,118.76h-96V345.84h96Zm109.69,0H311V345.84h96Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.69,398.52s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45a69.59,69.59,0,0,1-6.59-20.95c-1.49-11.37-6.28-24.83-6.28-24.83a10.54,10.54,0,0,1-2.39-2.2c-1-1.27-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.21,2.66,0,2.66,0l-1.06-15.44s.32-.85,1.17,0,1.92,8.95,1.92,8.95l1.38-.11.64-9.91s.43-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.28.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c1,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,382.58l-4.2-7.2c1.6-1.4,3-3.6,1.4-5.4a55.52,55.52,0,0,0-4.2-3.74l.18-.12a12.67,12.67,0,0,0,.18-3.07c-.18-1.09-.7-1.45-2.77-.91a5.76,5.76,0,0,1-2.46.08c-1.47-1.2-2.52-2-2.52-2s-5.8-4.39-14.2-.8-9.59,15-5.6,20.6,12.2,4.8,14.6,4.4,4.6-1.2,5.4-.4,7,9.19,7,9.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.75,383.17c-3.84,3-3.59,9-1.54,13,3.79,7.4,14.59,11.2,24.39,12.2s47,3,60.38.4A17.92,17.92,0,0,0,305.77,394s19.51-16.86,23.71-22.45,10.68-19.13,10.68-19.13,17.82-4.1,25.22-9.3,25.56-31.49,25.56-31.49,4.6,2.6,6.6.4,3.6-7,5.4-8.2,5.8-3.6,6.8-8,.2-9-1.2-8.4-4,4.6-8,7-8.8,8.59-13.2,11.59-17.79,16-30.79,22.39-26.19,14-27.39,15.6-15.39,7-23.19,14.59-13.39,16.8-14.19,17.6a25.19,25.19,0,0,1-9.4,4.4c-4.8,1.2-6.6,3.2-15.2,4s-20.39-1-20.39-1-1.6-7.2-7-8.2a18,18,0,0,0-13.39,3.2c-3.2,2.2-4.6,2.4-6.6,2.4-3.78,0-8.33-.3-11.63,1.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200.23,
    cy: 292.08,
    r: 48.92,
    transform: "translate(-147.89 227.13) rotate(-45)",
    style: {
      fill: "#2A52C3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211,399s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45A69.59,69.59,0,0,1,199,332.32c-1.49-11.37-6.28-24.83-6.28-24.83a10.64,10.64,0,0,1-2.39-2.19c-1-1.28-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.22,2.66,0,2.66,0l-1.06-15.45s.31-.85,1.17,0,1.91,8.95,1.91,8.95l1.39-.11.64-9.91s.42-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.27.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c.95,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,94.51a195,195,0,0,0-45.08,22.85,164.92,164.92,0,0,0-33.68,31.27c-49.27,60.55-57.13,155.88-11.56,225,25.14,38.1,73.3,77.05,118.41,72.67,31.9-3.1,60.9-20.6,93.69-17.59,33.78,3.09,64.51,7.76,95.1-10.57,32.77-19.62,52.33-58.37,58-98.4C450,270,441.31,212.48,418.69,167.1,374.24,77.94,253.7,63.58,168,94.51Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,94.51a195,195,0,0,0-45.08,22.85,164.92,164.92,0,0,0-33.68,31.27c-49.27,60.55-57.13,155.88-11.56,225,25.14,38.1,73.3,77.05,118.41,72.67,31.9-3.1,60.9-20.6,93.69-17.59,33.78,3.09,64.51,7.76,95.1-10.57,32.77-19.62,52.33-58.37,58-98.4C450,270,441.31,212.48,418.69,167.1,374.24,77.94,253.7,63.58,168,94.51Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.32,255.7s0-3.76-5.26-9-8.64-8.26-8.64-8.26-2.63,8.64,2.26,13.9a92.06,92.06,0,0,0,11.64,10.14Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.69,279.16s0-3.76-5.26-9-8.64-8.26-8.64-8.26-2.63,8.64,2.25,13.9a92.56,92.56,0,0,0,11.65,10.14Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,262.1s.4-3.74,6.18-8.41,9.47-7.31,9.47-7.31,1.7,8.87-3.71,13.59a92.4,92.4,0,0,1-12.65,8.85Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.77,289.81s.79-3.68,7-7.72S119,275.82,119,275.82s.76,9-5.11,13.12a92.5,92.5,0,0,1-13.52,7.48Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5,320s0-3.76,5.26-9,8.64-8.26,8.64-8.26,2.63,8.64-2.25,13.9a91.8,91.8,0,0,1-11.65,10.14Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42,327.39s.53-3.72-3.93-9.67-7.38-9.41-7.38-9.41-3.83,8.18.26,14.08a92.8,92.8,0,0,0,10.09,11.7Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.23,349.25s0-3.76,5.26-9,8.64-8.27,8.64-8.27,2.63,8.65-2.25,13.91A92.56,92.56,0,0,1,98.23,356Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74,369.06s-.95-3.63,2.81-10.05,6.26-10.19,6.26-10.19,4.74,7.69,1.34,14a91.61,91.61,0,0,1-8.7,12.76Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8,254.74a109.26,109.26,0,0,1-1.44,11.66c-2.08,10.74-7.28,17.67-9.36,27.38s3.89,22.2,2.29,34.66-6.45,19.39-5.06,27.71S106.89,387,106.89,387",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.94,
    y1: 264.59,
    x2: 116.61,
    y2: 260.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.2,
    y1: 259.58,
    x2: 108.83,
    y2: 255.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32,293.33s4.74-3.56,9.62-7.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.69,285.92A75.22,75.22,0,0,0,95.25,273",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.69,325.36a58.56,58.56,0,0,1,10.15-13.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.77,330.64a67.35,67.35,0,0,0-5.14-9.76c-2.77-4.09-3.17-4.61-3.17-4.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.23,356.15a63.05,63.05,0,0,1,4.27-8.64,56.11,56.11,0,0,1,5.54-7.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,375.6a16.11,16.11,0,0,1,1.43-8.32c2-3.82,4.21-8.83,5.14-10.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4,305.89s-.41-2.36,2.32-6.23,4.52-6.12,4.52-6.12,2.59,5.14.1,9a59.4,59.4,0,0,1-6.21,7.63Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.73,319.77s-.4-2.35,2.32-6.22,4.52-6.12,4.52-6.12,2.59,5.13.1,9a58.37,58.37,0,0,1-6.2,7.62Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,309.87s-.65-2.3-4.79-4.61-6.73-3.55-6.73-3.55-.1,5.75,3.8,8.11a58.81,58.81,0,0,0,8.9,4.18Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.09,326.24s-.89-2.22-5.24-4.07-7.07-2.83-7.07-2.83.5,5.73,4.63,7.67a58.36,58.36,0,0,0,9.29,3.22Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.29,345.37S79.88,343,76,340.29s-6.32-4.24-6.32-4.24-.71,5.7,2.92,8.47A58.53,58.53,0,0,0,81,349.61Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.14,350s-.74-2.28,1.41-6.49,3.61-6.7,3.61-6.7,3.29,4.71,1.37,8.85a59,59,0,0,1-5.06,8.43Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,369s.28-2.37,4-5.32,6.07-4.6,6.07-4.6,1,5.66-2.44,8.63a59,59,0,0,1-8.1,5.57Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.77,363.13s-.41-2.36-4.28-5.08-6.32-4.25-6.32-4.25-.71,5.71,2.93,8.47a58.65,58.65,0,0,0,8.4,5.1Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71,375.94s.21-2.39-2.85-6-5-5.71-5-5.71-2.13,5.34.68,8.94a58.72,58.72,0,0,0,6.84,7.05Z",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,305.34a67.43,67.43,0,0,0,2.17,7.16c2.47,6.51,6.48,10.29,8.84,16.15s0,14.34,2.32,22,6.15,11.46,6.19,16.83-2.09,20.28-2.09,20.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.61,
    y1: 311.43,
    x2: 65.58,
    y2: 309.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9,
    y1: 308.31,
    x2: 69.93,
    y2: 305.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.76,328.4S75.4,326.68,72,325",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.47,324a48.3,48.3,0,0,1,3.89-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,348.75a37.33,37.33,0,0,0-7.84-7.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9,352a42.15,42.15,0,0,1,2.16-6.67c1.3-2.87,1.49-3.24,1.49-3.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.33,371.53a35.67,35.67,0,0,1,4.33-4.5,22.93,22.93,0,0,0,2.81-2.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.52,367.46a40.51,40.51,0,0,0-3.62-5,35.43,35.43,0,0,0-4.26-3.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35,380.22a10.26,10.26,0,0,0-1.79-5.06c-1.66-2.18-3.61-5.08-4.4-6.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62,385.14H114a0,0,0,0,1,0,0V396a3.5,3.5,0,0,1-3.5,3.5H83.12a3.5,3.5,0,0,1-3.5-3.5V385.14A0,0,0,0,1,79.62,385.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,389.63H79.62a2.7,2.7,0,0,1-2.69-2.7h0a2.7,2.7,0,0,1,2.69-2.69h34.11a2.69,2.69,0,0,1,2.69,2.69h0A2.69,2.69,0,0,1,113.73,389.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-14"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 53.71,
    y1: 349.08,
    x2: 453.57,
    y2: 349.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.71,
    y1: 393.96,
    x2: 453.57,
    y2: 393.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.14,162v1.46H303C302.72,163,302.45,162.52,302.14,162Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.56,163.35c-3.43-1.87-5-.31-6.23-1.87s3.42-5.6-5.92-9.65c0,0-.62-8.72-13.39-9s-9.34,8.72-12.76,10.9-4.36-1.25-7.79.93-1.87,6.54-4.67,7.16-6.54-2.8-10-.62-3.43,4.05-5,4.05-4.67-1.25-6.54,0-4,2.8-4,2.8h78.78S221,165.22,217.56,163.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.59,199c-3.43-1.86-5-.31-6.23-1.86s3.42-5.61-5.92-9.66c0,0-.62-8.72-13.39-9s-9.34,8.72-12.76,10.9-4.36-1.24-7.79.94-1.87,6.53-4.67,7.16-6.54-2.8-10-.63-3.43,4.05-5,4.05-4.67-1.24-6.54,0-4,2.81-4,2.81h78.78S443,200.9,439.59,199Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.88,198.41c-2.14-1.17-3.11-.19-3.89-1.17s2.14-3.49-3.69-6c0,0-.39-5.44-8.36-5.64s-5.83,5.45-8,6.81-2.72-.78-4.86.58-1.17,4.08-2.91,4.47-4.09-1.75-6.22-.39-2.14,2.53-3.11,2.53-2.92-.78-4.09,0-2.52,1.75-2.52,1.75h49.17S237,199.58,234.88,198.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.86 353.92 41.86 270.65 91.31 270.65 91.31 170.79 124.61 170.79 124.61 192.71 143.26 192.71 143.26 257.26 188.54 257.26 188.54 221.94 209.85 221.94 209.85 241.42 225.53 241.42 232.56 241.42 233.12 248.73 251.52 248.73 251.52 219.5 266.17 219.5 266.17 128.16 302.13 128.16 302.13 163.48 328.77 163.48 328.77 119 358.07 119 358.07 228.03 388.71 228.03 388.71 268.22 410.1 268.22 410.1 355.72",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 192.42,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 192.42,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 208.67,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 208.67,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 208.67,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 224.93,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 241.19,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 257.45,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 273.71,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 289.97,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 224.93,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 224.93,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 241.19,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 241.19,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 257.45,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 257.45,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 273.71,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.19,
    y: 282.82,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.02,
    y: 265.26,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.43,
    y: 265.26,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 139.09,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 139.09,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 155.35,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 155.35,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 171.6,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 171.6,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 187.86,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 187.86,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 204.12,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 204.12,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.35,
    y: 204.12,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.95,
    y: 204.12,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.56,
    y: 204.12,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.35,
    y: 239.24,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.95,
    y: 239.24,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.56,
    y: 239.24,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.35,
    y: 274.36,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.95,
    y: 274.36,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.56,
    y: 274.36,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 220.38,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 220.38,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 236.64,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 236.64,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 252.9,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 252.9,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.57,
    y: 236.64,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 236.64,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.57,
    y: 252.25,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 252.25,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.57,
    y: 267.86,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 267.86,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.57,
    y: 283.47,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.38,
    y: 283.47,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 269.16,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 269.16,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 285.42,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 285.42,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 273.71,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 289.97,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 289.97,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 306.23,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 306.23,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 322.49,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.21,
    y: 322.49,
    width: 7.2,
    height: 7.8,
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.62,345.84h-96V118.76h96ZM297.3,118.76h-96V345.84h96Zm109.69,0H311V345.84h96Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.13,
    y: 174.04,
    width: 4.87,
    height: 224.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.49,
    y: 174.04,
    width: 36.15,
    height: 65.2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.47,
    y1: 233.85,
    x2: 405.47,
    y2: 235.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.47,
    y1: 176.4,
    x2: 405.47,
    y2: 229.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.15,
    y1: 184.87,
    x2: 409.15,
    y2: 235.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.15,
    y1: 176.4,
    x2: 409.15,
    y2: 180.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.78,
    y1: 176.4,
    x2: 415.78,
    y2: 235.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.94,
    y: 397.06,
    width: 29.86,
    height: 2.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "353.76 416.84 139.24 416.84 160.69 400.69 332.31 400.69 353.76 416.84",
    style: {
      fill: "#2A52C3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,398.52s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45a69.59,69.59,0,0,1-6.59-20.95c-1.49-11.37-6.28-24.83-6.28-24.83a10.54,10.54,0,0,1-2.39-2.2c-1-1.27-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.21,2.66,0,2.66,0l-1.06-15.44s.32-.85,1.17,0,1.92,8.95,1.92,8.95l1.38-.11.64-9.91s.43-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.28.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c1,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.69,398.52s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45a69.59,69.59,0,0,1-6.59-20.95c-1.49-11.37-6.28-24.83-6.28-24.83a10.54,10.54,0,0,1-2.39-2.2c-1-1.27-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.21,2.66,0,2.66,0l-1.06-15.44s.32-.85,1.17,0,1.92,8.95,1.92,8.95l1.38-.11.64-9.91s.43-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.28.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c1,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,398.52s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45a69.59,69.59,0,0,1-6.59-20.95c-1.49-11.37-6.28-24.83-6.28-24.83a10.54,10.54,0,0,1-2.39-2.2c-1-1.27-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.21,2.66,0,2.66,0l-1.06-15.44s.32-.85,1.17,0,1.92,8.95,1.92,8.95l1.38-.11.64-9.91s.43-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.28.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c1,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.46,378a11.6,11.6,0,0,0-11.27,7.61c-3.1,8.17,2.25,15.5-1.13,17.75s-14.65-.56-12.68,2.82,25.08,7.89,27.62-.56-6.2-17.19-5.07-22.54,4.79-4.23,4.79-4.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,382.58l-4.2-7.2c1.6-1.4,3-3.6,1.4-5.4a55.52,55.52,0,0,0-4.2-3.74l.18-.12a12.67,12.67,0,0,0,.18-3.07c-.18-1.09-.7-1.45-2.77-.91a5.76,5.76,0,0,1-2.46.08c-1.47-1.2-2.52-2-2.52-2s-5.8-4.39-14.2-.8-9.59,15-5.6,20.6,12.2,4.8,14.6,4.4,4.6-1.2,5.4-.4,7,9.19,7,9.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.8,375.38c1.16-1,2.2-2.44,2.1-3.83-4.45.95-9.33,1.59-11.24.42-3.85-2.37-10.95-9.47-17.75-5.33-5.2,3.16-.56,12.7,1.92,17a20.19,20.19,0,0,0,9.58.7c2.4-.4,4.6-1.2,5.4-.4s7,9.19,7,9.19l4.77-7,2.14-4.08Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214,382.58l-4.2-7.2c1.6-1.4,3-3.6,1.4-5.4a55.52,55.52,0,0,0-4.2-3.74l.18-.12a12.67,12.67,0,0,0,.18-3.07c-.18-1.09-.7-1.45-2.77-.91a5.76,5.76,0,0,1-2.46.08c-1.47-1.2-2.52-2-2.52-2s-5.8-4.39-14.2-.8-9.59,15-5.6,20.6,12.2,4.8,14.6,4.4,4.6-1.2,5.4-.4,7,9.19,7,9.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.41,377.18c-1-.6-.2-3.2-.8-6.2s-3-3.6-4-7c-.67-2.28.46-4.65,1.28-6a16.94,16.94,0,0,0-5.48,1.36c-8.4,3.6-9.59,15-5.6,20.6s12.2,4.8,14.6,4.4c1.9-.32,3.67-.88,4.72-.7a7.47,7.47,0,0,0,.28-1.9C199.41,378.38,195.41,377.78,194.41,377.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.15,374.6s-3.67-1.82-5,1.49,3.06,3.26,5.55,2.52a3.61,3.61,0,0,0,2.63-3.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,277.35a69.93,69.93,0,0,0-5.09-9.58,91.57,91.57,0,0,0-7.66-10.8c-3.73-4.52-5.69-5.3-3.53-6.48s5.1-2.36,10,.39,6.68,6.88,8.45,9.23,4.32,1,4.12,4.52a21.62,21.62,0,0,1-1.57,6.68l1.77,3.93-6.09,3.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,260.7a11.68,11.68,0,0,0,4.52,2.75c2.36.59,1.77,2.95,4.91,5.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67,379.27s0-.1-.1-.29,0-.09-.05-.13c-1.19-3.2-9.07-24.22-12.55-29.66-3.76-5.9-14.16-16.72-14.16-16.72s2.78-13.83.51-22.59c-1.74-6.71-15-28.86-19.53-35.63-1.72,0-3.8.22-6.11,3.1,2.68,7.62,7.33,20.27,8.43,31.34,1.42,14.42,3.9,29.44,5,31.13s1.15,16.87,5.52,26.84a101.83,101.83,0,0,0,9.09,15.91,24.36,24.36,0,0,1,.2,4.18c-.2.6-5.23,1.2-6.23,5.82s-1.81,12.86,8,14.87,17.67-.81,20.68-10.65S305.75,384.05,304.67,379.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.75,383.17c-3.84,3-3.59,9-1.54,13,3.79,7.4,14.59,11.2,24.39,12.2s47,3,60.38.4A17.92,17.92,0,0,0,305.77,394s19.51-16.86,23.71-22.45,10.68-19.13,10.68-19.13,17.82-4.1,25.22-9.3,25.56-31.49,25.56-31.49,4.6,2.6,6.6.4,3.6-7,5.4-8.2,5.8-3.6,6.8-8,.2-9-1.2-8.4-4,4.6-8,7-8.8,8.59-13.2,11.59-17.79,16-30.79,22.39-26.19,14-27.39,15.6-15.39,7-23.19,14.59-13.39,16.8-14.19,17.6a25.19,25.19,0,0,1-9.4,4.4c-4.8,1.2-6.6,3.2-15.2,4s-20.39-1-20.39-1-1.6-7.2-7-8.2a18,18,0,0,0-13.39,3.2c-3.2,2.2-4.6,2.4-6.6,2.4-3.78,0-8.33-.3-11.63,1.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.07,404.43c-8.48-5.05-43.25-7.34-52-7.34-10.64,0-12.46-7.42-17.88-7.67s-6.32-1.23-6.32-1.23-1.9-1.33-2.79-7.27c-.42,0-.84.06-1.3.06-3.38,0-7.36-.24-10.53,1.27,0,1.29.09,2.55.09,3.77,0,7.56-.83,11.81,9.38,19.7a50.39,50.39,0,0,0,11.86,2.65c9.79,1,47,3,60.38.4A18.77,18.77,0,0,0,300.07,404.43Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.75,383.17c-3.84,3-3.59,9-1.54,13,3.79,7.4,14.59,11.2,24.39,12.2s47,3,60.38.4A17.92,17.92,0,0,0,305.77,394s19.51-16.86,23.71-22.45,10.68-19.13,10.68-19.13,17.82-4.1,25.22-9.3,25.56-31.49,25.56-31.49,4.6,2.6,6.6.4,3.6-7,5.4-8.2,5.8-3.6,6.8-8,.2-9-1.2-8.4-4,4.6-8,7-8.8,8.59-13.2,11.59-17.79,16-30.79,22.39-26.19,14-27.39,15.6-15.39,7-23.19,14.59-13.39,16.8-14.19,17.6a25.19,25.19,0,0,1-9.4,4.4c-4.8,1.2-6.6,3.2-15.2,4s-20.39-1-20.39-1-1.6-7.2-7-8.2a18,18,0,0,0-13.39,3.2c-3.2,2.2-4.6,2.4-6.6,2.4-3.78,0-8.33-.3-11.63,1.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,408.3l.61.07c2.78.28,7.77.65,13.79,1-.91-2-3-7.05-2.2-11.16.95-4.92,2.79-7.52,4.52-14.93-.39-1.42-2.21-7-6.92-7.86a18,18,0,0,0-13.39,3.2c-3.2,2.2-4.6,2.4-6.6,2.4-3.78,0-8.33-.3-11.63,1.89l-.42.3a7.81,7.81,0,0,0-2.83,4.95c2.37-1.86,7.17-5.17,11.88-5.74l4.6-.4a8.7,8.7,0,0,0,3.4,7.19,18.37,18.37,0,0,0,7.8,3.6s1,8.8-1,12.4C230.75,406.68,230.27,407.66,230,408.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.94,309.5c-6.19,5.18-16.4,14-26.39,18.89-13,6.4-26.19,14-27.39,15.6s-15.39,7-23.19,14.59-13.39,16.8-14.19,17.6a25.19,25.19,0,0,1-9.4,4.4c-4.17,1-6.08,2.68-12.14,3.62v25.85c8.37,0,16-.37,20.74-1.28A17.92,17.92,0,0,0,305.77,394s19.51-16.86,23.71-22.45,10.68-19.13,10.68-19.13,17.82-4.1,25.22-9.3c5.68-4,18.49-21.57,23.24-28.2A9.08,9.08,0,0,0,382.94,309.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,380.58a28.72,28.72,0,0,0,15.5-13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.23,
    cy: 292.08,
    r: 48.92,
    transform: "translate(-147.89 227.13) rotate(-45)",
    style: {
      fill: "#2A52C3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.86,249.82l1.09.65a48.92,48.92,0,0,1-70.72,60.81,48.92,48.92,0,1,0,69.63-61.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,259.69c1.63,4.3-1.39,9.43-6.73,11.44s-11,.16-12.61-4.15,1.39-9.43,6.73-11.44S193.38,255.38,195,259.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200.23,
    cy: 292.08,
    r: 48.92,
    transform: "translate(-147.89 227.13) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,399s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45A69.59,69.59,0,0,1,199,332.32c-1.49-11.37-6.28-24.83-6.28-24.83a10.64,10.64,0,0,1-2.39-2.19c-1-1.28-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.22,2.66,0,2.66,0l-1.06-15.45s.31-.85,1.17,0,1.91,8.95,1.91,8.95l1.39-.11.64-9.91s.42-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.27.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c.95,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-14)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.52,398.4l9.1-11.29c-2.13-5.11-2.45-12.78-2-17s-1-16.73-1.27-19.18-2.88-10.23-5.76-17.26c-.66-1.61-1.53-3.62-2.48-5.77,1.66,5.22,4.87,15.6,5.81,20.27,1.28,6.39-4.26,8.09-5.53,14.48s0,15.75,0,23.41C209.36,390.9,209,394.41,211.52,398.4Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211,399s-7.48-6.88-6.28-15.26,1.49-14.06,1.49-14.06l-.59-16.45A69.59,69.59,0,0,1,199,332.32c-1.49-11.37-6.28-24.83-6.28-24.83a10.64,10.64,0,0,1-2.39-2.19c-1-1.28-2.66-2-4.15-3s-3.73-1-4.05-1.49-.53-1.28.43-1.28,3.62-.32,4.26.22,2.66,0,2.66,0l-1.06-15.45s.31-.85,1.17,0,1.91,8.95,1.91,8.95l1.39-.11.64-9.91s.42-.85,1.28,0l1.06,9.91,2.35-8.52s.85-1,1.27.32-1,9.16-1,9.16l4.15-5.33s.75-.1.75.43-3.31,7.14-3.31,7.14.32,7.77.11,8.41a9.36,9.36,0,0,0,.75,5.12c.95,2.45,7.67,16.72,10.54,23.75s5.44,14.81,5.76,17.26,1.7,14.92,1.27,19.18-.1,11.93,2,17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilatesBro);
export default __webpack_public_path__ + "static/media/Pilates-bro.d557d1dbd80c9a6744cc35b425213dfe.svg";
export { ForwardRef as ReactComponent };